import React, { useMemo, useContext } from "react";

import { TextElement } from "@/components/ui-kit/TextElement/TextElement";
import SearchContext from "@/context/SearchContext";
import { SuggestedItem, AlgoliaResult } from "@/types/search";

interface QueryTextProps {
  query: string;
  items: SuggestedItem[];
  data: AlgoliaResult[];
  onSuggestedClicked: (item: SuggestedItem) => void;
}

const QueryText: React.FC<QueryTextProps> = ({ query, items, data, onSuggestedClicked }) => {
  const { resultSearchVisible } = useContext(SearchContext);
  const { article, product } = resultSearchVisible ?? {};

  const suggestedItems = useMemo(() => {
    return items.filter((item) => item.query.toLowerCase() !== query.toLowerCase()).slice(0, 5);
  }, [items, query]);

  const results = useMemo(() => {
    return data.map((res) => res?.hits?.length && res.hits).filter(Boolean);
  }, [data]);

  const showResultsText =
    Boolean(article) || Boolean(product) || (results.length > 0 && suggestedItems.length === 0);

  return (
    <div>
      {showResultsText ? (
        <p className="search-result-text ml-4 md:h-[36px] pb-2 text-[12px] md:text-[16px]">
          <span className={`text-master-base-alt-alt`}>Showing results for</span>
          <span className="font-dinamoBold text-master-base-black">&nbsp;&quot;{query}&quot;</span>
        </p>
      ) : (
        suggestedItems.length > 0 && (
          <div className="flex items-baseline md:h-[36px] pb-2">
            <div className="inline-flex gap-2 md:gap-3 flex-wrap items-baseline">
              <TextElement
                text={`Suggested:`}
                className={`title--xsmall md:!text-[18px] xl:!text-[24px]`}
              />
              {suggestedItems.map((suggested, id) => (
                <button
                  key={suggested.query || id}
                  type="button"
                  className={`capitalize text-master-primary-default text-[14px] lg:text-[18px]`}
                  onClick={() => onSuggestedClicked(suggested)}
                  aria-label={suggested.query}
                >
                  {suggested.query}
                </button>
              ))}
            </div>
          </div>
        )
      )}
    </div>
  );
};

export default QueryText;
